import { render, staticRenderFns } from "./GenericAssessmentView.vue?vue&type=template&id=2467b2b3&scoped=true"
import script from "./GenericAssessmentView.vue?vue&type=script&lang=js"
export * from "./GenericAssessmentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2467b2b3",
  null
  
)

export default component.exports